import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import resumeData from '../data/resume'
import { motion } from 'framer-motion';

import { Worker } from '@react-pdf-viewer/core';

// Import the main component
import { Viewer } from '@react-pdf-viewer/core';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import CloseButton from '../components/common/CloseButton';
import request from 'graphql-request';

const Resume = () => {

    //const [resumesData, setResumesData] = useState([])
    //const [fileUrl, setFileUrl] = useState('')

    /* useEffect(() => {
        const fetchResume = async () => {
            const { resumesData } = await request(process.env.REACT_APP_API_URL, `{
                resumesData{
                    id
                    resume {
                    url(transformation: {image: {resize: {}}, document: {output: {}}})
                    }
                  }
            }`
            );
            setResumesData(resumesData);


        }
        fetchResume();
        setFileUrl(resumesData[0]?.resume.url)

    }, [resumesData]) */
    //console.log(resumeData[0]?.resume.url)

    return (
        <motion.div
            className='h-full'
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
        >
            <div className='bg-white dark:bg-gray-900 p-5 rounded-custom z-40 '>
                <div className='flex justify-between items-center'>
                    <h4 className='text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase'>My <span className='text-skin-base'>Resume</span></h4>
                    <CloseButton />
                </div>
                <div className='h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4'>
                    <div className='flex flex-col '>
                        <div className='mb-5 flex flex-col md:flex-row justify-center items-center gap-2'>
                            <Link to='/contact' className='bg-skin-fill text-white rounded-custom px-8 py-2 font-semibold text-md uppercase hover:opacity-90'>Hire me</Link>
                            <a href={resumeData[0].resume} className='bg-skin-fill text-white rounded-custom px-8 py-2 font-semibold text-md uppercase hover:opacity-90' download>Download Resume</a>
                        </div>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js">
                            <div className='h-auto bg-white dark:bg-gray-900'>
                                <Viewer fileUrl={resumeData[0].resume} className="bg-white dark:bg-gray-900" />
                            </div>
                        </Worker>
                        <div className='mt-5 flex flex-col md:flex-row justify-center items-center gap-2'>
                            <Link to='/contact' className='bg-skin-fill text-white rounded-custom px-8 py-2 font-semibold text-md uppercase hover:opacity-90'>Hire me</Link>
                            <a href={resumeData[0]?.resume} className='bg-skin-fill text-white rounded-custom px-8 py-2 font-semibold text-md uppercase hover:opacity-90' download>Download Resume</a>
                        </div>
                    </div>
                </div>

            </div>
        </motion.div>
    )
}

export default Resume